import { IPerson } from 'aa-ng';

export interface IPersonSummary extends IPerson {
  sumRank: number;
  degreeYear?: number;
  relevantWorksCount: number;
  relevantCollaborativeWorksCount: number;
  isKumcUser?: boolean;
}

export function mapPersonSummaryToPerson(
  personSummary: IPersonSummary,
): IPerson {
  return {
    ...personSummary,
    unitName: personSummary.primaryUnitAffiliation?.name,
  } as IPerson;
}
